export default __webpack_public_path__ + "static/media/teacup_wait.2c068c37.svg";